import { Container , Row, Col, Accordion, Card} from "react-bootstrap";
import { FaAirbnb, FaQuestionCircle } from "react-icons/fa";
import Footer from "../Footer";
import FAQ from "./Faq";
import { useState } from 'react';
import '../landing.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from "./Header";
import AIAgentCards from "./Cards";
import Testimonials from "./Testimonials";
import ai_img from '../assets/ai_secoond.jpg'
import ai_fourth from '../assets/ai_image.jpg'
import ai_fifth from '../assets/ai_fifth_image.jpg'
const Main = () => {
 const [activeIndex, setActiveIndex] = useState(0);

  // --- First Data: AI Agent FAQs ---
const faqDataFirst = [
  {
    question: 'What is an AI Agent?',
    answer:
      'An AI Agent is an intelligent software assistant that can understand language, automate tasks, answer questions, and interact with users — across channels like web, chat, or email — without human involvement.',
    image:
      ai_img,
  },
  {
    question: '⚙️ How does an AI Agent learn?',
    answer:
      'AI Agents are powered by large language models and trained on your company’s content, FAQs, documents, and APIs. They continuously improve by learning from interactions (with your permission).',
    image:
      ai_img,
  },
  {
    question: '🌐 Where can I deploy my AI Agent?',
    answer:
      'You can deploy AI Agents on websites, mobile apps, WhatsApp, email, social media, Slack, and more — all from a single dashboard.',
    image:
      ai_img,
  },
  {
    question: '🛡️ Is my data safe with AI Agent?',
    answer:
      'Yes. Your data stays private and is never used to train public models. AI Agent is built with enterprise-grade encryption and full data control.',
    image:
      ai_img,
  },
];


// --- Second Data: Generative AI FAQs ---
const faqDataSecond = [
  {
    question: 'What is Generative AI?',
    answer:
      'Generative AI refers to artificial intelligence systems that can create new content — such as text, images, audio, videos, and code. These models learn patterns from large datasets and generate original, human-like outputs based on that knowledge.',
    image:
      ai_img,
  },
  {
    question: 'How does Generative AI work?',
    answer:
      'Generative AI uses machine learning techniques like deep neural networks, particularly transformer models, to understand and replicate patterns in data. It predicts the next element in a sequence — such as a word or pixel — to create coherent and contextually accurate results.',
    image:
      ai_img,
  },
  {
    question: 'What are the main applications of Generative AI?',
    answer:
      'Generative AI powers chatbots, content creation tools, design assistants, coding copilots, data synthesis, and personalization engines. It’s used across industries like marketing, healthcare, finance, and entertainment to boost creativity and productivity.',
    image:
      ai_img,
  },
  {
    question: 'What are the benefits of Generative AI?',
    answer:
      'Generative AI enhances efficiency by automating repetitive tasks, accelerates content production, and enables personalized experiences. It also assists in brainstorming, data analysis, and rapid prototyping, freeing humans to focus on strategic and creative work.',
    image:
      'https://www.haptik.ai/hs-fs/hubfs/Productivity%20Boost.gif?width=2764&height=1784&name=Productivity%20Boost.gif',
  },
  {
    question: 'What are the challenges of Generative AI?',
    answer:
      'While powerful, Generative AI poses challenges around data privacy, bias, and content authenticity. Ensuring ethical use, transparency, and human oversight is crucial to prevent misinformation and maintain trust in AI-generated outputs.',
    image:
      'https://www.haptik.ai/hs-fs/hubfs/Data%20Ethics.gif?width=2764&height=1784&name=Data%20Ethics.gif',
  },
];

  return (
  <>
<Header />
    <br />
    <br />
    <br />
<h2 className="text-center pt-4 pb-4">Watch Our AI Agents in Action</h2>
<Container className="pt-4 pb-4">
    <Row className="g-4">
 <Col md={6}> <div className="container pt-4 pb-4">
     
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0" className="faq-card">
          <Accordion.Header className="">
            <FaQuestionCircle className="me-2 h1" />
            <span className="h3">Vision Agent</span>
          </Accordion.Header>
          <Accordion.Body>
            The Vision Agent interprets the physical world in real time — detecting defects, monitoring environments, and ensuring compliance across industries. Whether it’s factory floors or retail shelves, it keeps a constant, intelligent watch.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1" className="faq-card">
          <Accordion.Header>
            <FaQuestionCircle className="me-2 h1" />
           <span className="h3">Data Agent</span>
          </Accordion.Header>
          <Accordion.Body>
          Our Data Agent doesn’t just analyze numbers — it recognizes patterns, predicts outcomes, and recommends next steps. From trend forecasting to operational insights, it’s your decision-making engine in motion.
          </Accordion.Body>
        </Accordion.Item>

       <Accordion.Item eventKey="2" className="faq-card">
          <Accordion.Header>
            <FaQuestionCircle className="me-2 h1" />
           <span className="h3">Conversational Agent</span>
          </Accordion.Header>
          <Accordion.Body>
            The Conversational Agent handles customer interactions, onboarding, and training with empathy and accuracy — turning every exchange into a seamless experience.
          </Accordion.Body>
        </Accordion.Item>
 <Accordion.Item eventKey="3" className="faq-card">
          <Accordion.Header>
            <FaQuestionCircle className="me-2 h1" />
           <span className="h3"> Automation Agent</span>
          </Accordion.Header>
          <Accordion.Body>
           The Automation Agent orchestrates repetitive processes, syncs across platforms, and executes workflows flawlessly — ensuring speed, precision, and round-the-clock performance.
          </Accordion.Body>
        </Accordion.Item>
<Accordion.Item eventKey="4" className="faq-card">
          <Accordion.Header>
            <FaQuestionCircle className="me-2 h1" />
           <span className="h3"> Reasoning Agent</span>
          </Accordion.Header>
          <Accordion.Body>
            The Reasoning Agent uses contextual awareness and logic to solve complex problems, make autonomous decisions, and evolve continuously through experience. It doesn’t just follow rules — it understands them.
          </Accordion.Body>
        </Accordion.Item>

      </Accordion>
    </div></Col>
 <Col className="pt-4 pb-4"  md={6}><br /> <br /><img src={ai_fifth} alt="" className="img-fluid" width="550px" height="700px"/></Col>
    </Row>
</Container>
    <br />
    <br />
    <br />
<Container>
    <h3 className="text-center pt-4 pb-4"  style={{color: "rgb(91, 28, 151)"}}>Automate Data Extraction with Document Agents</h3>
    <p className="text-center pt-4 pb-4">Accelerate workflows by automatically reading and extracting information from files and cloud sources — from PDFs to Google Drive and Excel. <br />
    advanced intent detection, context-aware responses, and multilingual support in 100+ languages</p>
    <Row>
        <Col md={6}>
  <div
    className="second"
    style={{
      background: "linear-gradient(90deg, #8B196A, #fffdfe)",
      borderRadius: "10px",
      padding: "20px",
      boxShadow: "box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;"
    }}
  >
      <div className="d-flex justify-content-center align-items-center">  <img className="img-fluid" 
      src="https://www.haptik.ai/hs-fs/hubfs/01%20Voice%20First%20AI.gif?width=1200&height=588&name=01%20Voice%20First%20AI.gif"
      alt=""
      width="400px"
      height="300px"
      style={{color: "black"}}
     
    /></div>
    <h3 className="pt-4 pb-4 "  style={{color: " #ffffff"}}>Documents to Data, Instantly</h3>
    <p className="pt-4 pb-4 text-light">
    Upload, extract, and deliver — no manual effort, no errors.
    </p>
  </div>
</Col>

        <Col md={6}>
        <div   style={{
      background: "linear-gradient(90deg,rgb(252, 252, 252),rgba(253, 251, 252, 0.98))",
      borderRadius: "10px",
      padding: "20px",
      boxShadow: "box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;"
    }}>
        <h3  className="pt-4 pb-4 "  style={{color: " #8B196A"}}>Smart Reading, Seamless Transfer</h3>
         <p className="pt-4 pb-4 text-dark">
     Let the AI Document Agent capture and organize data from any document, then send it directly to your database, local folder, or desired destination — all in seconds.
    </p>
       <div className="d-flex justify-content-center align-items-center"> <img className="img-fluid" src="https://www.haptik.ai/hs-fs/hubfs/02%20Effortless%20Assistance.gif?width=2420&height=1360&name=02%20Effortless%20Assistance.gif" alt=""  width="400px"
      height="300px" /></div>
      </div>
        </Col>
    </Row>
   
</Container>
<br />
<br />
<br />
<Container>
    <Row>
        <Col md={6}>
  <div
    className="second"
    style={{
      background: "linear-gradient(90deg, #8B196A, #fffdfe)",
      borderRadius: "10px",
      padding: "20px",
      boxShadow: "box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;"
    }}
  >
      <div className="d-flex justify-content-center align-items-center">  <img 
      src="https://www.haptik.ai/hs-fs/hubfs/03%20Dynamic%20Call%20Routing.gif?width=2440&height=1256&name=03%20Dynamic%20Call%20Routing.gif"
      alt=""
      width="400px"
      height="300px"
      className="img-fluid"
      style={{color: "black"}}
     
    /></div>
    <h3 className="pt-4 pb-4" style={{color: " #ffffff"}} >From Files to Insights</h3>
    <p className="pt-4 pb-4 text-light">
    Upload, extract, and transfer — turning unstructured documents into ready-to-use data in seconds.
    </p>
  </div>
</Col>

        <Col md={6}>
        <div   style={{
      background: "linear-gradient(90deg,rgb(252, 252, 252),rgba(253, 251, 252, 0.98))",
      borderRadius: "10px",
      padding: "20px",
      boxShadow: "box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;"
    }}>
        <h3  className="pt-4 pb-4"  style={{color: " #8B196A"}}>Smart Document Understanding</h3>
         <p className="pt-4 pb-4 text-dark">
     Automatically capture, analyze, and organize data from any file — fast, accurate, and effortless.
    </p>
       <div className="d-flex justify-content-center align-items-center"> <img className="img-fluid" src="https://www.haptik.ai/hs-fs/hubfs/04%20An%20Empathetic%2c%20Intelligent%20Listener.gif?width=2420&height=1360&name=04%20An%20Empathetic%2c%20Intelligent%20Listener.gif" alt=""  width="400px"
      height="300px" /></div>
      </div>
        </Col>
    </Row>
   
</Container>
 <br />
    <br />
    
    <br />
  <Container>
    <h3 className="text-center pt-4 pb-4" style={{color: "#8B196A"}}>Your AI Agent Builder for High- <br />Impact Use Cases</h3>
  <Row className="pt-4 pb-4">
    <Col md={12}>
      <img
        src="https://www.haptik.ai/hs-fs/hubfs/AI%20Agent%20Builder_for%20High-Impact%20Use%20Cases%20(2).gif?width=3840&height=1200&name=AI%20Agent%20Builder_for%20High-Impact%20Use%20Cases%20(2).gif"
        alt=""
        className="img-fluid"
      />
    </Col>
  </Row>
</Container>

<br />
<br />
<br />
<Container>
  <Row>
    <Col>
      <Card
        style={{
          background: "rgb(254, 254, 254)",
          borderRadius: "15px",
          border: "1px solid rgb(238, 227, 227)",
          padding: "16px",
        }}
      >
        <div className="d-flex justify-content-center align-items-center mt-4">
          <span
            style={{
              backgroundColor: "#8B196A",
              fontSize: "1.5rem",
              borderRadius: "4px",
              color: "#fff",
            }}
          >
            <FaAirbnb className="m-2" />
          </span>
          <h5 className="ms-4 fw-bold mt-1" style={{ color: "#8B196A" }}>
            Smart Workflow Automation
          </h5>
        </div>
        <p className="d-flex justify-content-center align-items-center ps-4 mt-3 text-center">
          Let your AI Agent handle repetitive tasks like ticket routing, appointment
          booking, and data collection — freeing up your team to focus on what matters.
        </p>
      </Card>
    </Col>

    <Col>
      <Card
        style={{
          background: "rgb(254, 254, 254)",
          borderRadius: "15px",
          border: "1px solid rgb(238, 227, 227)",
          padding: "16px",
        }}
      >
        <div className="d-flex justify-content-center align-items-center mt-4">
          <span
            style={{
              backgroundColor: "#8B196A",
              fontSize: "1.5rem",
              borderRadius: "4px",
              color: "#fff",
            }}
          >
            <FaAirbnb className="m-2" />
          </span>
          <h5 className="ms-4 fw-bold mt-1" style={{ color: "#8B196A" }}>
            Easy Third-Party Integrations
          </h5>
        </div>
        <p className="d-flex justify-content-center align-items-center ps-4 mt-3 text-center">
          Connect your AI Agent with tools like CRMs, Slack, Notion, or your internal
          APIs — so it can fetch answers, update records, or trigger actions in real-time.
        </p>
      </Card>
    </Col>

    <Col>
      <Card
        style={{
          background: "rgb(254, 254, 254)",
          borderRadius: "15px",
          border: "1px solid rgb(238, 227, 227)",
          padding: "16px",
        }}
      >
        <div className="d-flex justify-content-center align-items-center mt-4">
          <span
            style={{
              backgroundColor: "#8B196A",
              fontSize: "1.5rem",
              borderRadius: "4px",
              color: "#fff",
            }}
          >
            <FaAirbnb className="m-2" />
          </span>
          <h5 className="ms-4 fw-bold mt-1" style={{ color: "#8B196A" }}>
            Real-Time Analytics & Insights
          </h5>
        </div>
        <p className="d-flex justify-content-center align-items-center ps-4 mt-3 text-center">
          Track every interaction with live dashboards. Understand what users ask, how
          your agent responds, and where you can optimize performance.
        </p>
      </Card>
    </Col>
  </Row>
</Container>

 <br />
    <br />
   
    <br />
    <br />
<FAQ />
<AIAgentCards />
<Container>
  <h3 className="pt-4  text-center fw-bold">The Haptik Advantage</h3>
  <p  className="pb-4 text-center">Purpose-built for efficiency</p>
  <Row>
    <Col>
  <Card style={{background: "rgb(254, 254, 254)", borderRadius: "15px", border: "1px solid rgb(238, 227, 227)", padding: "16px"}}>
  
     <div className="d-flex justify-content-center align-items-center mt-4"> <span style={{backgroundColor: "#8B196A",  fontSize: "1.5rem", borderRadius: "4px", color: "#fff"}}><FaAirbnb className="m-2"/> </span><h5 className="ms-4 fw-bold mt-1" style={{color: "#8B196A"}}>Flexible Model Selection</h5></div>
    <p className="d-flex justify-content-center align-items-center ps-4 mt-3">Experiment with leading AI models like GPT, <br />
    llama, and Claude to find the best <br />
    fit for your business needs</p>
  
  </Card>
    </Col>
    <Col> <Card style={{background: "rgb(254, 254, 254)", borderRadius: "15px", border: "1px solid rgb(238, 227, 227)", padding: "16px"}}>
  
     <div className="d-flex justify-content-center align-items-center mt-4"> <span style={{backgroundColor: "#8B196A",  fontSize: "1.5rem", borderRadius: "4px", color: "#fff"}}><FaAirbnb className="m-2"/> </span><h5 className="ms-4 fw-bold mt-1" style={{color: "#8B196A"}}>Multilingual Support</h5></div>
    <p className="d-flex justify-content-center align-items-center ps-4 mt-3">Experiment with leading AI models like GPT, <br />
    llama, and Claude to find the best <br />
    fit for your business needs</p>
  
  </Card></Col>
    <Col> <Card style={{background: "rgb(254, 254, 254)", borderRadius: "15px", border: "1px solid rgb(238, 227, 227)", padding: "16px"}}>
  
     <div className="d-flex justify-content-center align-items-center mt-4"> <span style={{backgroundColor: "#8B196A",  fontSize: "1.5rem", borderRadius: "4px", color: "#fff"}}><FaAirbnb className="m-2"/> </span><h5 className="ms-4 fw-bold mt-1" style={{color: "#8B196A"}}>Omnichannel Engagement</h5></div>
    <p className="d-flex justify-content-center align-items-center ps-4 mt-3">Experiment with leading AI models like GPT, <br />
    llama, and Claude to find the best <br />
    fit for your business needs</p>
  
  </Card></Col>
  </Row>
</Container>
<Testimonials />
  <Container>
         <h3 
            style={{
           
              fontWeight: '700',
              marginBottom: '40px',
              color: 'black',
              textAlign: "center"
            }}
          >
          Your Data. Your AI. Your Advantage.
          </h3>
    <div className="container my-5 py-5">
      <div className="row align-items-center">
        {/* Left Side - FAQ Questions */}
         {/* Right Side - Image */}
        <div className="col-lg-6 col-md-12 mt-4 mt-lg-0">
          <div
            style={{
              position: 'relative',
              borderRadius: '20px',
              overflow: 'hidden',
              boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
              height: '500px'
            }}
          >
            <img
              src={faqDataFirst[activeIndex].image}
              alt={faqDataFirst[activeIndex].question}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                transition: 'opacity 0.5s ease-in-out'
              }}
            />
         
          </div>
        </div>
        <div className="col-lg-6 col-md-12">
         

          <div className="accordion" id="faqAccordion">
            {faqDataSecond.map((faq, index) => (
              <div 
                key={index}
                className="mb-3"
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '10px',
                  boxShadow: activeIndex === index 
                    ? '0 6px 12px rgba(106, 29, 194, 0.2)' 
                    : '0 2px 8px rgba(0, 0, 0, 0.1)',
                  border: activeIndex === index 
                    ? '2px solid rgba(106, 29, 194, 0.5)' 
                    : '2px solid transparent',
                  transition: 'all 0.3s ease',
                  overflow: 'hidden'
                }}
              >
                <h2 className="accordion-header">
                  <button
                    className={`accordion-button ${activeIndex === index ? '' : 'collapsed'}`}
                    type="button"
                    onClick={() => setActiveIndex(index)}
                    style={{
                      backgroundColor: activeIndex === index ? 'rgba(106, 29, 194, 0.1)' : '#fff',
                      color: activeIndex === index ? '#6A1DC2' : '#333',
                      fontWeight: '600',
                      fontSize: '1.5rem',
                      padding: '20px 25px',
                      border: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    {faq.question}
                  </button>
                </h2>
                <div
                  className={`accordion-collapse collapse ${activeIndex === index ? 'show' : ''}`}
                >
                  <div 
                    className="accordion-body"
                    style={{
                      padding: '20px 25px',
                      color: '#666',
                      fontSize: '1rem',
                      lineHeight: '1.6'
                    }}
                  >
                    {faq.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
    </Container>
    <br />
    <br />
    <br />
    <Footer />
  </>
  );
};

export default Main;
